// extracted by mini-css-extract-plugin
module.exports = {"root":"Drawer_root__2OXoU"};